import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar,frFR } from '@mui/x-data-grid';
import axios from 'axios';
import Cookies from 'js-cookie'

import { useDispatch} from 'react-redux'
import {  useNavigate  } from "react-router-dom";

import { getUserRule } from '../../utils/userRule';
import Autorize from '../../components/ui/autorize';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Clubs() {

    const [clublist, setList] = useState("");
    const [autorize, setAutorize] = useState(false);
    const [errorAxios, setErrorAxios] = useState(false);
  
 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })
    

  

    useEffect(() => { 
                    
        const fetchData = async () => {
            try {
                console.log("fetchData");
            // Vos opérations asynchrones, par exemple une requête HTTP
                let RuleRead_Club = await getUserRule("read_club",sessionStorage.getItem('clubId'),sessionStorage.getItem('secteur'));            
            //setRuleRead(RuleRead_Club);

                if(RuleRead_Club === true)
                {              
                                MyAxios.get(process.env.REACT_APP_API + '/clubs/getall') //axios.defaults.withCredentials = true
                                .then((res) => {      
                                    setErrorAxios(false);
                                    console.log(res);
                                    setList(res.data);
                                    setAutorize(true);
                                })
                                .catch((error) => {
                                    console.log(error)  
                                    setErrorAxios(true);                 
                    
                                });
                    //********************************************** 
                }

            
            console.log("RuleRead_Club Clubs",RuleRead_Club);
            // Faire quelque chose avec les données
            } catch (error) {
            console.error('Une erreur s\'est produite lors de la récupération des données', error);
            }
        };

         fetchData(); // Appel de la fonction asynchrone
  


    },[""]);
   
        const columns = [           
            {      field: 'id',            headerName: 'Numéro de club' ,           width:100},           
            {      field: 'Club_Type',     headerName: 'Type de club',     width:150},  
            {      field: 'ClubLegalName', headerName: 'Nom légal', width:400},
            {      field: 'Status',        headerName: 'Statut',        width:100},       
            {      field: 'Status_Reason', headerName: 'Raison du statut', width:125},             
            {      field: 'Incorporated',  headerName: 'Incorporé',  width:100}, 
            {      field: 'SportsClub',    headerName: 'Club à vocation unique',    width:100},   
            {      field: 'CollegeClub',   headerName: 'Club universitaire',   width:100},              
        ];

        const navigate = useNavigate();       
        const dispatch = useDispatch();

       // let navigate = useNavigate(); 
        const onRowClicked = (row, event) => {

             console.log(row.id);  
             dispatch({ type: 'set' , payload:  row.id});
             sessionStorage.setItem('clubId',  row.id);
             navigate('/club',)
           
         };
       


    function mainHtml()
    {

        if(autorize)
        {
            return (<div>
                        <div style={{ height: 600, width: '90%' }}>
                    
                            <DataGrid  localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                rows={clublist}
                                columns={columns}
                                pageSize={25}
                                rowsPerPageOptions={[25]}
                                components={{ Toolbar: GridToolbar }} 
                                onRowClick={(rowData) => onRowClicked(rowData.row)}                         
                            />
                        </div>
                    </div>);
        }
        else
            return "";

    }


        return (
                  <div>
                     <Autorize key="clubListe1" axiosError={errorAxios} />
                     {mainHtml()}
                 
                </div>
        );
   
};

export default Clubs;